import { fetchAsync } from '../utils/fetch';

interface File extends Blob {
  readonly lastModified: number;
  readonly name: string;
}

export const postMeasureTemplate = async (file: File, dateId) => {
  const data = new FormData();
  data.append('file', file);
  data.append('dateId', dateId);
  const result = fetchAsync('/api/measure/import', {
    method: 'POST',
    body: data,
    type: 'blob',
  });
  return result;
};
